var render = function render(){var _vm=this,_c=_vm._self._c;return _c('app-input',_vm._b({attrs:{"value":_vm.slug_value},on:{"input":_vm.onInput}},'app-input',_vm.$props,false))
}
var staticRenderFns = []

export { render, staticRenderFns }